export default "__VITE_ASSET__1638812d__"